import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Autocomplete, TextField } from '@mui/material'

import { useAppDispatch } from '@/state'
import { ApplicationState } from '@/state/root.models'
import { ListBrands } from '@/state/brands/models'

import {
  authSelector,
  setSelectBrandAction,
} from '@/state/auth/slices/index.slices'
import { Brands } from '@/state/user/models'
import useStyles from './style'

const BrandsComponent = () => {
  const { classes } = useStyles()

  const dispatch = useAppDispatch()

  const { brand } = useSelector(authSelector)

  const { loggedUser } = useSelector(({ auth }: ApplicationState) => auth)

  const setBrandAction = useCallback((value: ListBrands) => {
    dispatch(setSelectBrandAction(value))
  }, []) // eslint-disable-line

  const handleOnChange = (value: ListBrands) => {
    setBrandAction(value)
  }

  const enableBrands = loggedUser.brands
    .filter((item) => item.enable)
    .sort((a: Brands, b: Brands) => a.name.localeCompare(b.name))

  return (
    <Autocomplete
      id="brands"
      options={enableBrands}
      getOptionLabel={(option: ListBrands) => option.name}
      isOptionEqualToValue={(option: ListBrands, value: ListBrands) =>
        option.id === value.id
      }
      renderInput={(params) => <TextField {...params} variant="outlined" />}
      className={classes.selectBrand}
      value={brand}
      onChange={(event, value: any) => {
        if (value !== null) {
          handleOnChange(value)
        }
      }}
    />
  )
}

export default BrandsComponent
